/**
 * 「参照ではなく中身で比べる」 ための鍵。
 *
 * snapshot は broadcast のたびに作り直される (対人戦は DO が JSON を再シリアライズし、
 * ローカル CPU 戦は engine が新しい state を返す) ので、 **その盤で何も起きていなくても
 * `boards[i].state` や `lastMove` の参照は毎回変わる**。
 *
 * 参照で「変わったか」 を判定すると、 並列マッチで相手が別の盤を指しただけで
 * 「この盤に何か起きた」 と誤判定する。 実害はどれも「気づきにくい形の入力事故」:
 *
 *   - 直前手のアニメがもう一度走る (2026-09-19 修正)
 *   - 2 タップ確定の 1 タップ目が消えて、 2 タップ目が効かない (2026-09-19 修正)
 *
 * 同じ落とし穴が hooks/useLegalMoves.ts にもあり、 そちらは内容ハッシュの
 * キャッシュで避けている。 新しく state の変化を検知するコードを書くときは、
 * まずここを使うか、 なぜ参照比較で足りるのかを書き残すこと。
 */
export function contentKey(v: unknown): string {
  if (v == null) return '';
  return typeof v === 'string' ? v : JSON.stringify(v);
}
